import React from "react";
import Modal from "./Modal";

const ConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = "Potvrda",
  message = "Da li ste sigurni da želite da nastavite?",
  confirmText = "Potvrdi",
  cancelText = "Otkaži",
}) => {
  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      subtitle={message}
      leftButtonText={cancelText}
      rightButtonText={confirmText}
      onLeftButtonClick={handleCancel}
      onRightButtonClick={handleConfirm}
      showButtons={true}
      showCloseButton={true}
      closeOnOverlayClick={true}
    />
  );
};

export default ConfirmModal;
